import $ from 'jquery'
import messageResource from '../messageResource'
import {ReportColumnsFormatCostOfWork} from 'constants'
import {Feature, isEnabled} from '../features'

export default function ReportColumnsSelectorButtonsCostOfWork(){}

ReportColumnsSelectorButtonsCostOfWork.prototype.init = function(config){
    this.showSpentTimeCheckbox = $("#showSpentTime");
    this.showAverageRatesCheckbox = $("#showAverageRates");
    this.showUserRatesCheckBox = $("#showUserRates");

    const configChangedCallback  = config.changeCallback;
    this.showSpentTimeCheckbox.on("change", configChangedCallback);
    this.showAverageRatesCheckbox.on("change", configChangedCallback);
    this.showUserRatesCheckBox.on("change", configChangedCallback);

    if(this.verifyIsNeedGroupSelector(config.columnsFormat)){
        $("#columnsFormatSectionCostWork" ).toggleClass("showUGR");
        $("#columnsFormatCheckboxesTable" ).toggleClass("showUGR");
        $("#columnsFormatSectionCostWork_selectorSection").show();
        $("#columnsFormatCheckboxesTable_showAverageRates" ).find("label").html(messageResource.getMessage("report.cost.show_average_rates.short"));
        $("#columnsFormatCheckboxesTable_showSpentTime" ).find("label").html(messageResource.getMessage("report.cost.show_spent_time.short"));
        $("#columnsFormatCheckboxesTable_showUserRates" ).find("label").html(messageResource.getMessage("report.cost.show_user_rates.short"));
        $("#columnsFormatCheckboxesTable_showSubtotalByDepartments" ).show();
    }else{
       $("#columnsFormatCheckboxesTable_showAverageRates" ).find("label").html(messageResource.getMessage("report.cost.show_average_rates"));
       $("#columnsFormatCheckboxesTable_showSpentTime" ).find("label").html(messageResource.getMessage("report.cost.show_spent_time"));
       $("#columnsFormatCheckboxesTable_showUserRates" ).find("label").html(messageResource.getMessage("report.cost.show_user_rates"));
    }

    if(config.selector)
    {
        this.selector = config.selector;
        this.showSubtotalByDepartmentsCheckbox = $("#showSubtotalByDepartments");
        this.showSubtotalByDepartmentsCheckbox.on("change", configChangedCallback);
        this.containerWithChexboxes = $("#"+config.containerId );
        const self = this;
        const toggleClass = function ()
        {
            self.containerWithChexboxes.toggleClass( "hideSubtotalByDepartments", self.selector.getValue() === ReportColumnsFormatCostOfWork.USERS_ONLY );
            self.containerWithChexboxes.toggleClass( "hideUserRatesAndSubtotalByDepartments ", self.selector.getValue() === ReportColumnsFormatCostOfWork.GROUPS_ONLY );
        };
        this.selector.on( "change",
                          function ()
                          {
                              toggleClass()
                          }
        );
        toggleClass();
    }
    this.setValue(config.columnsFormat, config.showSpentTime, config.showAverageRates,config.showUserRates, config.showSubtotalsByDepartments);
    return this;
};

ReportColumnsSelectorButtonsCostOfWork.prototype.getSelection = function(){
  const result = {};
  result.columnsConfig = this.selector ? this.selector.getValue() : ReportColumnsFormatCostOfWork.USERS_ONLY;
  result.showSpentTime = this.showSpentTimeCheckbox .is(':checked');
  result.showAverageRates =  this.showAverageRatesCheckbox.is(':checked');
  result.showUserRates = this.showUserRatesCheckBox.is(':checked') ? !(this.selector && this.selector.getValue() === ReportColumnsFormatCostOfWork.GROUPS_ONLY) : false;
  result.showSubtotalsByDepartments = this.showSubtotalByDepartmentsCheckbox &&
                                     this.selector.getValue() === ReportColumnsFormatCostOfWork.USERS_BY_GROUPS &&
                                     this.showSubtotalByDepartmentsCheckbox.is(':checked');
  return result;
};

ReportColumnsSelectorButtonsCostOfWork.prototype.setValue = function(columnsConfig, showSpentTime, showAverageRates, showUserRates, showSubtotalByDepartments){
    if(this.selector) this.selector.setActiveItemByValue(columnsConfig);
    this.showSpentTimeCheckbox.prop('checked', showSpentTime);
    this.showAverageRatesCheckbox.prop('checked', showAverageRates);
    this.showUserRatesCheckBox.prop('checked',   this.selector && this.selector.getValue() === ReportColumnsFormatCostOfWork.GROUPS_ONLY ? false : showUserRates);
    if(this.showSubtotalByDepartmentsCheckbox) this.showSubtotalByDepartmentsCheckbox.prop('checked',showSubtotalByDepartments  &&
                                                        this.selector.getValue() === ReportColumnsFormatCostOfWork.USERS_BY_GROUPS);
};

ReportColumnsSelectorButtonsCostOfWork.prototype.verifyIsNeedGroupSelector = function ( reportInfo ) {
    return isEnabled(Feature.UGR) || reportInfo !== ReportColumnsFormatCostOfWork.USERS_ONLY;
};




// WEBPACK FOOTER //
// ./web/js/controls/ReportColumnsSelectorButtonsCostOfWork.js